import LyInputNumber from './src/index.vue'

LyInputNumber.install = function (Vue) {
    Vue.component(LyInputNumber.name, LyInputNumber)
}

export default LyInputNumber



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/input-number/index.js
// module id = null
// module chunks = 